import { Component, OnInit } from '@angular/core';
import { ProfileSyncService } from '../../../services/profile-sync.service';
import { EventEmitterWithObservable } from '../../../../shared/EventEmitterWithValueReturned';
import { SnfLegacyMigrationService } from '../../../services/snf-legacy-migration.service';

@Component({
    selector: 're-snf-legacy-user-import-list',
    templateUrl: './snf-legacy-user-import-list.component.html',
    styleUrls: ['./snf-legacy-user-import-list.component.scss'],
    standalone: false
})
export class SnfLegacyUserImportListComponent implements OnInit {

  constructor(private sngLegacyService: SnfLegacyMigrationService) { }
  ngOnInit(): void {
  }
  load($event: EventEmitterWithObservable) {

    $event.ReturnValue = this.sngLegacyService.getTransactions();
  }

}
